import useTheme from "@/hooks/useTheme";
import Head from "next/head";

export default function PreloadedStaticImg() {
	const theme = useTheme();

	if (theme === "light")
		return (
			<Head>
				<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-passport-light.png" />
				<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-id-card-light.png" />

				<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/upload-back-light.png" />
				<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/upload-passport-light.png" />
				<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/upload-front-light.png" />
			</Head>
		);

	return (
		<Head>
			<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-passport-dark.png" />
			<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-id-card-dark.png" />

			<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/upload-front-dark.png" />
			<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/upload-passport-dark.png" />
			<link rel="preload" as="image" href="https://web-cdn.rockflow.tech/h5/survey/upload-back-dark.png" />
		</Head>
	);
}
